module.exports = __webpack_public_path__ + "img/head2green.67e22981.png";